import { LAB_TESTING_ADD, LAB_TESTING_VIEW  } from '@/utils/permissions'

export default [
  {
    path: '/lab-test/add',
    name: 'lab-test-add',
    component: () => import('@/views/lab-tests/AddLabTest.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'New Lab Test',
      breadcrumb: [{ title: 'Dashboard', url: '/dashboard' }, { title: 'Lab Test' }, { title: 'Add Lab Test', active: true }],
      permissions: [LAB_TESTING_ADD]
    }
  },
  {
    path: '/lab-test/list',
    name: 'lab-test-list',
    component: () => import('@/views/lab-tests/LabTestList.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Lab Test List',
      breadcrumb: [{ title: 'Dashboard', url: '/dashboard' }, { title: 'Lab Test' }, { title: 'Lab Test List', active: true }],
      permissions: [LAB_TESTING_VIEW]
    }
  }
]

export const blankRoutes = [
  {
    path: '/lab-test/:id/lab-test-pdf',
    name: 'lab-test-view-pdf',
    component: () => import('@/views/lab-tests/LabTestPDF.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Lab Test List',
      breadcrumb: [{ title: 'Dashboard', url: '/dashboard' }, { title: 'Lab Test' }, { title: 'Lab Test PDF', active: true }]
    }
  }
]